import noodleApiClient from '@/tsClient/servers/noodleApi';

type Resolution = {
  fieldPath: string;
  value: unknown;
  sourceCategory: string;
  notes?: string;
};

type ResolveConflictsInput = {
  caseId: string;
  resolutions?: Resolution[];
  acceptAllFromSource?: {
    sourceCategory: string;
    sourceId?: string;
  };
};

type ResolveConflictsResponse = {
  caseId: string;
  resolvedCount: number;
};

const resolveConflicts = async ({
  caseId,
  resolutions,
  acceptAllFromSource,
}: ResolveConflictsInput): Promise<ResolveConflictsResponse> => {
  const response = await noodleApiClient.post(`/cases/${caseId}/resolutions`, {
    acceptAllFromSource,
    resolutions,
  });
  return response.data as ResolveConflictsResponse;
};

export type { Resolution, ResolveConflictsInput, ResolveConflictsResponse };
export default resolveConflicts;
